// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  /* .speakerDiv {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  
  .speakerDiv.Active {
    border-radius: 23px;
    background-color: var(--active-speaker-div);
    padding-left: 16px;
  }
  


  
   */`, "",{"version":3,"sources":["webpack://./src/Core/Components/Tooltip/Tooltip.css"],"names":[],"mappings":"EAAE;;;;;;;;;;;;;;;IAeE","sourcesContent":["  /* .speakerDiv {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n  }\n  \n  .speakerDiv.Active {\n    border-radius: 23px;\n    background-color: var(--active-speaker-div);\n    padding-left: 16px;\n  }\n  \n\n\n  \n   */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
